import Cookies from '@comeon/tomcat-cookies';

function getLocale() {
	let locale = null;
	try {
		locale = Cookies.get('locale');
	} catch (e) {
		// eslint-disable-next-line no-console
		console.warn('locale.js: can not get cookie "locale"', e);
	}
	// Edge case scenario where user clears quickies after he visits landing page, and proceeds with registration.
	if (!locale) {
		locale = (navigator && navigator.language) || 'en-GB';
	}
	const replaced = locale && locale.replace ? locale.replace('_', '-') : null;
	return replaced;
}

export default getLocale;
